// check if SizeGuideDrawer exists before defining it
if (!window.customElements.get('size-guide-drawer')) {
  class SizeGuideDrawer extends Drawer {
    constructor() {
      super();
      this.inputElName = 'size-guide-toggle';
      this.measurementContentAttr = 'data-size-guide-unit';
      this.currentMeasurement = this.getCurrentMeasurement();
      this.toggleMeasurementContent(this.currentMeasurement);
    }

    close() {
      this.classList.remove('active');
      removeTrapFocus(this.activeElement);
      if (document.querySelector('shop-the-look-drawer.active')) return;
      document.body.classList.remove('overflow-hidden');
      setTimeout(() => {
        document.body.classList.remove('drawer--isActive');
      }, 300);
    }

    connectedCallback() {
      this.setupToggleListeners();
      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      this.querySelector('[id*=-Overlay]').addEventListener('click', this.close.bind(this));
    }

    getCurrentMeasurement() {
      const toggle = this.querySelector(`[name="${this.inputElName}"]:checked`);
      return toggle.value === 'cm' ? 'cm' : 'in';
    }

    toggleMeasurementContent(measurement) {
      const contentEls = this.querySelectorAll(`[${this.measurementContentAttr}]`);
      contentEls.forEach((contentEl) => {
        contentEl.classList.add('hidden');
      });

      const currentContentEl = this.querySelector(`[${this.measurementContentAttr}="${measurement}"]`);
      if (currentContentEl) {
        currentContentEl.classList.remove('hidden');
      }
    }

    setupToggleListeners() {
      const toggleElements = this.querySelectorAll(`[name="${this.inputElName}"]`);
      toggleElements.forEach((toggleEl) => {
        toggleEl.addEventListener('change', () => {
          this.currentMeasurement = this.getCurrentMeasurement();
          this.toggleMeasurementContent(this.currentMeasurement);
        });
      });
    }
  }

  customElements.define('size-guide-drawer', SizeGuideDrawer);
}
